"use client";

import { useSearchParams } from "next/navigation";

/** The register route, carrying the sign-in page's query (for example `callbackUrl`) through to account creation. */
export function useRegisterHref() {
  const query = useSearchParams().toString();

  if (!query) {
    return "/register";
  }

  return `/register?${query}`;
}
